import type { TableColumn } from "@components";
import type { ComponentType } from "react";
import type { ExpenseConsolidatedByPlateItem, ExpenseTypeCode } from "../types";
import { REPORT_SUMMARY_CARD_ICONS } from "./expense-report-summary-card";

type CategoryColumn<T> = TableColumn<T> & {
	Icon?: ComponentType<{ className?: string }>;
	type?: ExpenseTypeCode;
};

export const EXPENSES_CONSOLIDATED_BY_PLATE_COLUMNS: CategoryColumn<ExpenseConsolidatedByPlateItem>[] =
	[
		{
			id: "plate",
			label: "Placa",
			minWidth: 140,
		},
		{
			id: "model",
			label: "Modelo",
		},
		{
			id: "infraction",
			label: "Infração",
			Icon: REPORT_SUMMARY_CARD_ICONS[1],
			type: 1,
		},
		{
			id: "maintenance",
			label: "Manutenção",
			Icon: REPORT_SUMMARY_CARD_ICONS[2],
			type: 2,
		},
		{
			id: "toll",
			label: "Pedágio",
			Icon: REPORT_SUMMARY_CARD_ICONS[3],
			type: 3,
		},
		{
			id: "reimbursement",
			label: "Reembolso",
			Icon: REPORT_SUMMARY_CARD_ICONS[4],
			type: 4,
		},
		{
			id: "fuel",
			label: "Combustível",
			Icon: REPORT_SUMMARY_CARD_ICONS[5],
			type: 5,
		},
		{
			id: "trip",
			label: "Viagem",
			Icon: REPORT_SUMMARY_CARD_ICONS[6],
			type: 6,
		},
		{
			id: "other",
			label: "Outros",
			Icon: REPORT_SUMMARY_CARD_ICONS[7],
			type: 7,
		},
		{
			id: "total",
			label: "Total",
		},
	];
